import {
    REFEREE_DELETE_FAILURE,
    REFEREE_DELETE_REQUEST,
    REFEREE_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    deleting: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case REFEREE_DELETE_SUCCESS: {return {
            ...state,
            deleting: false,
            hasErrors: false,
        }}

        case REFEREE_DELETE_REQUEST: {return {
            ...initialState,
            deleting: true,
        }}

        case REFEREE_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
